var Level;
(function (Level) {
    Level["EASY"] = "EASY";
    Level["MEDIUM"] = "MEDIUM";
    Level["HARD"] = "HARD";
    Level["CUSTOM"] = "CUSTOM";
})(Level || (Level = {}));
export default Level;
